import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#016981",
        mainAction: "#F69333",
        secondary: "#4A5159",
        background: "#f9f9f9",
      },
    },
  },
});
